(function () {
  var API = 'https://cool-steal-game.scott-af6.workers.dev';

  var CLAIM_RE = /^\d{5}-\d{5}$/;
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  var ERRORS = {
    already_claimed:  "This claim has already been used. Only one free tee per person.",
    not_found:        "That claim number and email don't match. Check both and try again.",
    not_approved:     "Your win is still being reviewed — we'll email you shortly.",
    size_unavailable: "That one just sold out. Pick another colour or size.",
    missing_fields:   "Please fill in every required field.",
    invalid:          "That claim number doesn't look right.",
    order_failed:     "Something went wrong creating your order. Try again in a minute."
  };

  var ALWAYS_REQUIRED = ['claim_id', 'email', 'first_name', 'last_name', 'phone', 'address1', 'city', 'country_code'];

  var countriesByCode = null;
  function countryInfo(code) {
    if (!countriesByCode) {
      countriesByCode = {};
      if (window.Countries) {
        Object.keys(window.Countries).forEach(function (name) {
          var c = window.Countries[name];
          if (c && c.code) countriesByCode[c.code] = c;
        });
      }
    }
    return countriesByCode[code] || null;
  }

  function initClaim(root) {
    if (root.hasAttribute('data-shoplift-claim-init')) return;
    var form = root.querySelector('.shoplift-claim__form');
    var dataEl = root.querySelector('[data-claim-product]');
    if (!form || !dataEl) return;
    root.setAttribute('data-shoplift-claim-init', '');

    var product = JSON.parse(dataEl.textContent);
    var colours = [].slice.call(form.querySelectorAll('[data-colour]'));
    var sizes = [].slice.call(form.querySelectorAll('[data-size]'));
    var country = form.elements.country_code;
    var province = form.elements.province_code;
    var zip = form.elements.zip;
    var errorBox = form.querySelector('.shoplift-claim__error');
    var submit = form.querySelector('.shoplift-claim__submit');
    var success = root.querySelector('.shoplift-claim__success');
    var busy = false;

    var goneIds = {};

    // ---- Product picker ----
    function variantFor(colour, size) {
      for (var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i];
        if (v.options[product.colour] === colour && v.options[product.size] === size) return v;
      }
      return null;
    }

    function checked(inputs) {
      for (var i = 0; i < inputs.length; i++) if (inputs[i].checked) return inputs[i];
      return null;
    }

    function selectedVariant() {
      var c = checked(colours);
      var s = checked(sizes);
      return c && s ? variantFor(c.value, s.value) : null;
    }

    function setSoldOut(input, soldOut) {
      input.disabled = soldOut;
      input.parentNode.classList.toggle('is-soldout', soldOut);
      if (soldOut) input.checked = false;
    }

    function renderStock() {
      colours.forEach(function (c) {
        setSoldOut(c, !product.variants.some(function (v) {
          return v.options[product.colour] === c.value && v.available;
        }));
      });

      var colour = checked(colours);
      sizes.forEach(function (s) {
        var available = colour
          ? !!(variantFor(colour.value, s.value) || {}).available
          : colours.some(function (c) { return !!(variantFor(c.value, s.value) || {}).available; });
        setSoldOut(s, !available);
      });
    }

    // The page can be served from cache, so ask the storefront for live stock.
    function refreshStock() {
      var handle = root.getAttribute('data-product-handle');
      return fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (live) {
          if (!live) return;
          var byId = {};
          live.variants.forEach(function (v) { byId[v.id] = v.available; });
          product.variants.forEach(function (v) {
            if (v.id in byId) v.available = byId[v.id] && !goneIds[v.id];
          });
          renderStock();
        })
        .catch(function (err) {
          console.warn('shoplift claim: stock refresh failed', err.message);
        });
    }

    colours.forEach(function (c) { c.addEventListener('change', renderStock); });


    // ---- Size chart popup ----
    var sizeChart = root.querySelector('.shoplift-claim__size-chart');
    if (sizeChart && typeof sizeChart.showModal === 'function') {
      root.querySelectorAll('[aria-controls="' + sizeChart.id + '"]').forEach(function (btn) {
        btn.addEventListener('click', function () { sizeChart.showModal(); });
      });
      sizeChart.querySelector('[data-size-chart-close]').addEventListener('click', function () {
        sizeChart.close();
      });
      // The dialog has no padding, so a click that lands on the dialog itself was on the backdrop.
      sizeChart.addEventListener('click', function (e) {
        if (e.target === sizeChart) sizeChart.close();
      });
    }


    // ---- Country / province / postcode ----
    function renderCountry() {
      var info = countryInfo(country.value);
      var provinces = info && info.provinces;

      province.innerHTML = '';
      if (provinces && provinces.length) {
        var label = info.province_label || 'State / province';
        province.appendChild(new Option(label + ' *', ''));
        provinces.forEach(function (name) {
          var text = (info.province_labels && info.province_labels[name]) || name;
          province.appendChild(new Option(text, info.province_codes[name]));
        });
        province.setAttribute('aria-label', label);
        province.hidden = false;
      } else {
        province.hidden = true;
      }

      var zipLabel = (info && info.zip_label) || 'Postcode';
      zip.required = !info || info.zip_required !== false;
      zip.placeholder = zipLabel + (zip.required ? ' *' : '');
      zip.setAttribute('aria-label', zipLabel);
    }

    country.addEventListener('change', renderCountry);


    // ---- Errors ----
    function fieldEl(name) {
      return form.querySelector('[data-field="' + name + '"]') || form.elements[name];
    }

    function clearErrors() {
      errorBox.hidden = true;
      errorBox.textContent = '';
      [].forEach.call(form.querySelectorAll('.is-error'), function (el) {
        el.classList.remove('is-error');
      });
    }

    function showError(code, fields) {
      errorBox.textContent = ERRORS[code] || ERRORS.order_failed;
      errorBox.hidden = false;

      var first = null;
      (fields || []).forEach(function (name) {
        var el = fieldEl(name);
        if (!el || el.hidden) return;
        el.classList.add('is-error');
        first = first || el;
      });
      (first || errorBox).scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    form.addEventListener('input', function (e) {
      var el = e.target.closest('[data-field]') || e.target;
      el.classList.remove('is-error');
    });


    // ---- Submit ----
    function value(name) {
      return (form.elements[name].value || '').trim();
    }

    function collect() {
      var variant = selectedVariant();
      return {
        claim_id: value('claim_id'),
        email: value('email'),
        first_name: value('first_name'),
        last_name: value('last_name'),
        phone: value('phone'),
        address1: value('address1'),
        address2: value('address2'),
        city: value('city'),
        province_code: province.hidden ? '' : province.value,
        zip: value('zip'),
        country_code: country.value,
        consent: form.elements.consent.checked,
        marketing_consent: form.elements.marketing_consent.checked,
        variant_id: variant ? variant.id : ''
      };
    }

    // Mirrors the Worker's checks so the common mistakes don't need a round trip.
    function validate(body) {
      var missing = ALWAYS_REQUIRED.filter(function (name) { return !body[name]; });
      if (body.email && !EMAIL_RE.test(body.email)) missing.push('email');
      if (!province.hidden && !body.province_code) missing.push('province_code');
      if (zip.required && !body.zip) missing.push('zip');
      if (!body.variant_id) missing.push('variant_id');
      if (!body.consent) missing.push('consent');

      if (missing.length) return { error: 'missing_fields', fields: missing };
      if (!CLAIM_RE.test(body.claim_id)) return { error: 'invalid', fields: ['claim_id'] };
      return null;
    }

    function done(order) {
      form.hidden = true;
      if (order) {
        success.querySelector('[data-order]').textContent = order;
        success.querySelector('.shoplift-claim__order').hidden = false;
      }
      success.hidden = false;
      success.focus();
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (busy) return;
      clearErrors();

      var body = collect();
      var problem = validate(body);
      if (problem) {
        showError(problem.error, problem.fields);
        return;
      }

      busy = true;
      submit.disabled = true;
      form.classList.add('is-loading');

      fetch(API + '/claim', {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain' },
        body: JSON.stringify(body)
      }).then(function (res) {
        return res.json().catch(function () { return {}; });
      }).then(function (data) {
        if (data.ok) {
          done(data.order);
          return;
        }
        if (data.error === 'size_unavailable') {
          var gone = selectedVariant();
          if (gone) {
            gone.available = false;
            goneIds[gone.id] = true;
          }
          renderStock();
          refreshStock();
          showError('size_unavailable', ['variant_id']);
          return;
        }
        showError(data.error, data.fields);
      }).catch(function (err) {
        console.warn('shoplift claim failed:', err.message);
        showError('order_failed');
      }).then(function () {
        busy = false;
        submit.disabled = false;
        form.classList.remove('is-loading');
      });
    });

    // The winner email links here with ?claim_id=&email=.
    var params = new URLSearchParams(window.location.search);
    if (params.get('claim_id')) form.elements.claim_id.value = params.get('claim_id');
    if (params.get('email')) form.elements.email.value = params.get('email');

    renderCountry();
    renderStock();
    refreshStock();
  }

  function initAll(scope) {
    scope.querySelectorAll('[data-shoplift-claim]').forEach(initClaim);
  }

  initAll(document);

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
